// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1yYK0","select":"Header_select__1SRCp","clinic":"Header_clinic__1DMhp"};